/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReserveShiftsReportRow,
    ReserveShiftsReportRowFromJSON,
    ReserveShiftsReportRowFromJSONTyped,
    ReserveShiftsReportRowToJSON,
} from './';

/**
 * GO Reserve 乗務リポートリスト
 * @export
 * @interface ReserveShiftsReportList
 */
export interface ReserveShiftsReportList {
    /**
     * 
     * @type {Array<ReserveShiftsReportRow>}
     * @memberof ReserveShiftsReportList
     */
    shiftReports?: Array<ReserveShiftsReportRow>;
}

export function ReserveShiftsReportListFromJSON(json: any): ReserveShiftsReportList {
    return ReserveShiftsReportListFromJSONTyped(json, false);
}

export function ReserveShiftsReportListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveShiftsReportList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftReports': !exists(json, 'shift_reports') ? undefined : ((json['shift_reports'] as Array<any>).map(ReserveShiftsReportRowFromJSON)),
    };
}

export function ReserveShiftsReportListToJSON(value?: ReserveShiftsReportList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_reports': value.shiftReports === undefined ? undefined : ((value.shiftReports as Array<any>).map(ReserveShiftsReportRowToJSON)),
    };
}


